export default {
    props: {
        adminInfo: {
            type: Object,
            default: null
        }
    },
    data(){
        return {
            module: '',
            createDialog: false,
            editDialog: false,
            currentRow: null,
            formSearch: {},
            tableLoading: true,
            tableData: [],
            total: 0,
            currentPage: 1,
            params: {},
            showAll: false,
            deleteModule: '',
            hasPage: true,
        }
    },
    mounted() {
        this.$emit('loadOk')
        this.init()
    },
    methods: {
        init(){

        },
        createNew(){
            this.createDialog = true;
        },
        cancelCreate(){
            this.createDialog = false;
        },
        createOk(){
            this.$message({
                message: '新增成功！',
                type: 'success'
            })
            this.createDialog = false;
            this.getLists(this.currentPage);
        },
        pageChange(page){
            this.getLists(page)
        },
        onSearch(){
            this.getLists();
        },
        async getLists(page){
            if(page && page > this.currentPage){
                return 
            }
            if(this.showAll){
                if(!page || page == 1){
                    this.tableData = []
                }
            }
            this.tableLoading = true;
            this.params.page = page ? page: 1
            try{
                let res = await this.$api.rApi(this.module + '/lists', this.params);
                if(res && res.status == 1){
                    if(this.hasPage){
                        if(this.listsFn){
                            res.data.data = this.listsFn(res.data.data)
                        }
                        if(!this.showAll){
                            this.tableData = res.data.data;
                        }else{
                            this.tableData = this.tableData.concat(res.data.data)   
                        }
                        this.currentPage = res.data.current_page;
                        this.total = res.data.total;
                    }else{
                        this.tableData = res.data
                    }
                }else{
                    this.tableData = this.showAll ? this.tableData : [];
                    if(this.hasPage){
                        this.total = 0;
                        this.currentPage = 1;
                    }
                }
            }catch(e){
                this.tableData = this.showAll ? this.tableData : [];
                if(this.hasPage){
                    this.total = 0;
                    this.currentPage = 1;
                }
            }finally{
                this.tableLoading = false;
            }
        },
        editRow(row){
            this.editDialog = true;
            this.currentRow = row;
        },
        cancelEdit(){
            this.editDialog = false;
        },
        editOk(){
            this.editDialog = false;
            this.currentRow = null;
            this.$message({
                message: '保存成功！',
                type: 'success'
            })
            this.getLists(this.currentPage);
        },
        deteleRow(row){
            this.$confirm('此操作将永久删除信息, 是否继续?', '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await this.$api.rApi((this.deleteModule ? this.deleteModule : this.module) + '/delete', {
                    id: row.id
                }, true)
                if(res && res.status == 1){
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    })
                    this.getLists(this.currentPage);
                }
            }).catch(() => {
            });
        },
        getCategoryName(row){
            if(!row) return ''
            if(row.shopCategory && row.shopCategory.name) return row.shopCategory.name
            if(row.shopCategoryName) return row.shopCategoryName
            let keys = Object.keys(row)
            for(let i = 0; i < keys.length; i++){
                let k = keys[i]
                if(k.toLowerCase() === 'shopcategoryname' && row[k]){
                    return row[k]
                }
            }
            return ''
        }
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/mixin.js